import { createSelector } from '@ngrx/store';

import { inboxFeature } from './inbox.reducer';

export const { selectInboxState } = inboxFeature;

export const selectInbox = createSelector(
  selectInboxState,
  (state) => state.collection
);
